// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_2-TabsIcon_tabs_3XMZV"};